<template>
    <div class="page-wrapper">
        <NavBar class="style1" />
        <div class="content-wrapper">
            <PageTitle pageTitle="Organisation" />
            <Organisation />
        </div>
        <FooterComp />
    </div>
</template>

<script>
import NavBar from '../Layouts/NavBar'
import PageTitle from '../Common/PageTitle'

import FooterComp from '../Layouts/FooterComp'
import Organisation from '../Organisation/Organisation.vue'

export default {
    name: 'ParutionPage',
    components: {
        NavBar,
        PageTitle,
        Organisation ,
        FooterComp,
    }
}
</script>